import { createBrowserRouter } from 'react-router-dom'
import AlterarSenha from '../View/Controller/AlterarSenha'
import Clientes from '../View/Crud/Clientes'
import ErroAplicacao from '../Layout/ErroAplicacao'
import ExemploMenu from '../exemplo_apagar/menu'
import Grupos from '../View/Crud/Sistema/Grupos'
import Layout from '../Layout/Layout'
import Logout from '../View/Controller/Logout'
import SetCliente from '../View/Controller/SetCliente'
import TesteBox from '../exemplo_apagar/TesteBox'
import Usuarios from '../View/Crud/Sistema/Usuarios'
import FatorRHCadastroCorrespondencia from '../View/Crud/FATORRH/FatorRHCadastroCorrespondencia'
import DRGCadastroCorrespondencia from '../View/Crud/DRG/DRGCadastroCorrespondencia'
import DRGClientesDePara from '../View/Crud/DRG/DRGClientesDePara'
import DRGCadastroXML from '../View/Crud/DRG/DRGCadastroXML'
import DRGCadastroSQL from '../View/Crud/DRG/DRGCadastroSQL'
import DRGEnvio from '../View/Crud/DRG/DRGEnvio'
import FatorRHClientesDePara from '../View/Crud/FATORRH/FatorRHClientesDePara'
import FatorRHEnvio from '../View/Crud/FATORRH/FatorRHEnvio'
import FatorRHCadastroJSON from '../View/Crud/FATORRH/FatorRHCadastroJSON'
import FatorRHCadastroSQL from '../View/Crud/FATORRH/FatorRHCadastroSQL'
import Veiculos from '../View/Crud/Veiculos'
import HistoricoLocalizacao from '../View/Relatorios/HistoricoLocalizacao'

// TODO - Novo Menu / Modulo
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErroAplicacao />,
    children: [
      {
        path: "AlterarSenha",
        element: <AlterarSenha />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "DRGCadastroCorrespondencia",
        element: <DRGCadastroCorrespondencia />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "FatorRHCadastroCorrespondencia",
        element: <FatorRHCadastroCorrespondencia />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Clientes",
        element: <Clientes />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "DRGClientesDePara",
        element: <DRGClientesDePara />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "DRGEnvio",
        element: <DRGEnvio />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "DRGCadastroXML",
        element: <DRGCadastroXML />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "DRGCadastroSQL",
        element: <DRGCadastroSQL />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "FatorRHClientesDePara",
        element: <FatorRHClientesDePara />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "FatorRHEnvio",
        element: <FatorRHEnvio />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "FatorRHCadastroJSON",
        element: <FatorRHCadastroJSON />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "FatorRHCadastroSQL",
        element: <FatorRHCadastroSQL />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Grupos",
        element: <Grupos />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Logout",
        element: <Logout />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "SetCliente",
        element: <SetCliente />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Usuarios",
        element: <Usuarios />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "Veiculos",
        element: <Veiculos />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "HistoricoLocalizacao",
        element: <HistoricoLocalizacao />,
        errorElement: <ErroAplicacao />
      },
      {
        path: "/TesteBoxComLogin",
        element: <TesteBox />
      }
    ]
  },
  {
    path: "/ErroAplicacao",
    element: <ErroAplicacao />
  },
  {
    path: "/ExemploMenu",
    element: <ExemploMenu />
  },
  {
    path: "/TesteBox",
    element: <TesteBox />
  },
]);